
import React, { useEffect, useState } from "react";
import { Card, CardHeader, Row, Col } from "reactstrap";
import SignUpChart from "../components/Dashboard/SignUpChart.js"
import PlayerMinsChart from "../components/Dashboard/PlayerMinsChart.js"
import CodeIssuedChart from "../components/Dashboard/CodeIssuedChart.js"
import ProfileAndRatingChart from "../components/Dashboard/ProfileAndRatingChart.js"

function Dashboard(props) {

    const [signupMethod, setSignupMethod] = useState("All")
    const [numberLastDays, setNumberLastDays] = useState(7)

    useEffect(() => {
        document.title = 'Dashboard - TMH Admin';
    })

    return (
        <div className="content">
            <Row>
                <Col md="12">
                    <Card className="card-chart">
                        <CardHeader>
                            <Row>
                                <Col md="6">
                                    Source: {" "}
                                    <select value={signupMethod} onChange={(e) => setSignupMethod(e.target.value)}>
                                        <option>All</option>
                                        <option>FreeMovieHouse</option>
                                        <option>FreeMovieSpin</option>
                                        <option>MobileApp</option>
                                        <option>Mobile/FreeMovieHouse</option>
                                        <option>Mobile/FreeMovieSpin</option>
                                    </select>
                                </Col>
                                <Col md="6">
                                    Compare with last: {" "}
                                    <select value={numberLastDays} onChange={(e) => { setNumberLastDays(e.target.value) }}>
                                        <option>7</option>
                                        <option>10</option>
                                        <option>15</option>
                                        <option>20</option>
                                        <option>30</option>
                                        <option>40</option>
                                        <option>50</option>
                                        <option>60</option>
                                        <option>70</option>
                                        <option>80</option>
                                    </select>
                                    {" "} days
                                </Col>
                            </Row>
                            <Row>
                                <Col md="1" />
                                <Col md="10" className="m-3" style={{
                                    "border": "1px solid #ffffff05"
                                }} />
                            </Row>
                        </CardHeader>
                    </Card>
                </Col>
            </Row>
            <SignUpChart signupMethod={signupMethod} numberLastDays={numberLastDays} />
            <PlayerMinsChart signupMethod={signupMethod} numberLastDays={numberLastDays} />
            <CodeIssuedChart signupMethod={signupMethod} numberLastDays={numberLastDays} />
            <ProfileAndRatingChart signupMethod={signupMethod} numberLastDays={numberLastDays} />
        </div>
    );
}
export default Dashboard;
